<a
    class="mlp-tag-link mr-1 mb-1 d-inline-block"
    [routerLink]="['/blog/category', findCategorySlug(categoryId)]"
    (click)="$event.stopPropagation()"
    *ngFor="let categoryId of blog?.categories | slice: 0:maxCategories"
>
    {{ findCategory(categoryId) }}
</a>
